export { DashboardPage } from './view/dashboard-page';
